<template>
    <div class="text-response">
        <span v-if="response != null && response[0]" class="choice answer">
            <template v-if="isNonBlankAnswer(response[0])">
                {{ response[0] }}
            </template>
            <template v-else>&nbsp;</template>
        </span>
        <div v-else :class="['no-answer', {'is-multi' : isMulti}]">
            <span>
                Not Answered
            </span>
        </div>
    </div>
</template>

<script>

export default {   
    name: 'text-response-partial',

    props: {
		response: {
			type: [Array, Object],
		},
        isMulti: {
            type: Boolean
        }
    },
    
    methods: {
        isNonBlankAnswer(answer) {
            if(answer)
			    return answer.trim().length > 0
            return false
		},
	},
}
</script>

<style lang="scss" scoped>
@import "../style.scss";
</style>
